// extracted by mini-css-extract-plugin
export var section = "_4g-1";
export var topNav = "_4g-0";